import type {getTeacherTools_aiGuideTeacherTools as TeacherTool} from "./__graphql-types__/getTeacherTools.ts";
import {getTools, type Tool} from "./ai-tools-list.ts";

// filters in-memory TeacherTool list
// by results returned from aiGuideTeacherTool
export const determineToolsList = (curatedTools: TeacherTool[]): Tool[] => {
    const tools = getTools();

    const filteredTools: Tool[] = [];

    for (const curatedTool of curatedTools) {
        const inMemoryTool = tools.find(
            (tool: Tool) => tool.configName === curatedTool.configName,
        );

        if (inMemoryTool) {
            filteredTools.push(inMemoryTool);
        }
    }

    return filteredTools;
};
